import { subdomains } from "@/common/consts";
import ArticlesHome from "@/pages/Articles/Home/ArticlesHome.vue";
import ArticleDetail from "@/pages/Articles/Detail/ArticleDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        meta: {
            subdomain: subdomains.ABBREVIATIONS
        },
        component: ArticlesHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "ArticleDetail",
        meta: {
            subdomain: subdomains.ABBREVIATIONS
        },
        component: ArticleDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.abbreviations.js